<template>
  <div class="video-page">
    <div class="video-page-body">
      <div class="video-item">
        <div class="item-title">
          <span>*</span>
          <p>上传视频</p>
        </div>
        <p class="item-tips">
          支持mp4，avi，wmv，mov，flv，rmvb，3gp，mkv；单文件大小不超过500MB
        </p>
        <p class="item-tips">
          标题命名：章节+资源类型+学年+年级+学期+学科+版本+册别
        </p>
        <div class="item-content item-content2">
          <div class="file-list" id="file-list">
            <div
              v-for="(item, index) in videoFiles"
              :key="index"
              class="video-info"
              id="file-list"
            >
              <img
                src="../../../assets/images/sort-icon.png"
                alt=""
                class="sort-icon"
              />
              <div
                class="video-name-box"
                :class="{
                  'only-look': $route.query.operationType == 2,
                  'current-file': index === currentFileIndex || isAllSet,
                }"
                @click="selectCurrentFile(index)"
              >
                <img
                  src="../../../assets/images/video-icon.png"
                  alt=""
                  class="video-icon"
                />
                <input
                  type="text"
                  class="video-name"
                  placeholder="请输入视频名称"
                  maxlength="80"
                  :disabled="$route.query.operationType == 2"
                  v-model="form.fileName[index]"
                />
                <i
                  v-if="
                    uploadingStatus[index] === '上传成功' ||
                    uploadingStatus[index] === '失败' ||
                    $route.query.operationType == 1
                  "
                  class="iconfont icon-guanbi video-del"
                  @click.stop="delVideo(index)"
                ></i>
              </div>
              <div v-show="showProgress[index]" class="uploading-box">
                <div
                  class="upload-status"
                  :class="{
                    'upload-success': uploadingStatus[index] === '上传成功',
                    'upload-error': uploadingStatus[index] === '失败',
                  }"
                >
                  {{ uploadingStatus[index] }}
                </div>
                <el-progress
                  v-show="uploadingStatus[index] === '上传中'"
                  :percentage="uploadingProgress[index]"
                  style="width: 175px"
                ></el-progress>
                <el-progress
                  v-show="uploadingStatus[index] === '失败'"
                  :percentage="uploadingProgress[index]"
                  style="width: 175px"
                  status="exception"
                ></el-progress>
              </div>
            </div>
          </div>
          <div
            v-show="
              !!$route.query.operationType
                ? videoFiles.length < 1
                : videoFiles.length < 20
            "
            class="upload-btn-box"
          >
            <div class="upload-video-btn" @click="clickUpload('video')">
              <i class="iconfont icon-jiahao add-icon"></i>
              <p>请上传视频</p>
            </div>
            <div v-show="itemTips.fileUrl" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
          <input
            ref="videoFile"
            type="file"
            id="video-file"
            multiple
            @change="selectFile($event, 'video')"
            accept=".mp4,.avi,.wmv,.mov,.flv,.rmvb,.3gp,.m4v,.mkv"
            style="display: none"
          />
        </div>
      </div>
      <div v-show="videoFiles.length > 1" class="batch-operations-item">
        <p class="batch-operations-tips">
          温馨提示：每份视频需分别打标，若成套系视频打标点击下方批量操作
        </p>
        <el-checkbox v-model="isAllSet" data-io-click="tracker">
          批量操作
        </el-checkbox>
      </div>
      <div class="cover-item">
        <div class="item-title">
          <span>*</span>
          <p>封面</p>
          <p class="item-tips">
            尺寸为266px*140px，支持JPG、JPEG、PNG，大小不超过500KB
          </p>
        </div>
        <div class="item-content">
          <div
            v-if="!form.coverUrl[currentFileIndex]"
            class="upload-cover-btn"
            @click="clickUpload('cover')"
          >
            <i class="iconfont icon-jiahao add-icon"></i>
            <p>请上传封面</p>
          </div>
          <div
            class="cover-img"
            :style="
              'background-image: url(' + form.coverUrl[currentFileIndex] + ')'
            "
            v-else
            cache-control="no-cache"
          >
            <div
              v-if="$route.query.operationType == 2"
              class="mengban-box"
            ></div>
            <div
              class="masking"
              v-show="$route.query.operationType != 2"
              @click="clickUpload('cover')"
            >
              修改封面
            </div>
          </div>
          <input
            ref="coverFile"
            type="file"
            id="video-file"
            @change="selectFile($event, 'cover')"
            accept=".jpg,.png,.jpeg"
            style="display: none"
          />
          <div v-show="itemTips.coverUrl[currentFileIndex]" class="must-tip">
            <img
              src="../../../assets/images/must-tip-icon.png"
              alt=""
              class="must-tip-icon"
            />
            <span>必填项</span>
          </div>
        </div>
      </div>
      <div class="grade-subjecj-item">
        <div class="subject-item">
          <div class="item-title">
            <span>*</span>
            <p>学科</p>
          </div>
          <div class="item-content">
            <el-cascader
              v-model="form.courseId[currentFileIndex]"
              :props="{ value: 'id', emitPath: false }"
              :options="courseList"
              clearable
              :show-all-levels="false"
              :disabled="!!$route.query.operationType"
              placeholder="请选择学科"
              @change="courseChange()"
            ></el-cascader>
            <div v-show="itemTips.courseId[currentFileIndex]" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
        <div class="scene-item">
          <div class="item-title">
            <span>*</span>
            <p>场景</p>
          </div>
          <div class="item-content">
            <el-cascader
              v-model="form.scenarioId[currentFileIndex]"
              :options="sceneList"
              placeholder="请选择场景"
              :disabled="$route.query.operationType == 2"
              :props="{ value: 'id', emitPath: false }"
            ></el-cascader>
            <div
              v-show="itemTips.scenarioId[currentFileIndex]"
              class="must-tip"
            >
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
      </div>
      <div class="scene-date-item">
        <div class="date-item">
          <div class="item-title">
            <span>*</span>
            <p>年份</p>
          </div>
          <div class="item-content">
            <el-select
              v-model="form.year[currentFileIndex]"
              placeholder="请选择年份"
              :disabled="$route.query.operationType == 2"
            >
              <el-option
                v-for="item in yearList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <div v-show="itemTips.year[currentFileIndex]" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
        <div class="try-item">
          <div class="item-title">
            <span>*</span>
            <p>试看范围</p>
            <div class="radio-list">
              <el-radio-group
                v-model="tryLookRadio[currentFileIndex]"
                @input="tryLookChange"
              >
                <el-radio label="1">固定时长</el-radio>
                <el-radio label="2">固定比例</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="item-content">
            <el-input
              type="text"
              :placeholder="tryLookPlaceholder"
              v-model="form.trialRange[currentFileIndex]"
              show-word-limit
              :disabled="tryLookRadio[currentFileIndex] === '3'"
              @input="tryLookChangeValue"
            >
              <template
                v-if="tryLookRadio[currentFileIndex] === '2'"
                slot="append"
                >%</template
              >
              <template
                v-if="tryLookRadio[currentFileIndex] === '1'"
                slot="append"
                >分钟</template
              >
            </el-input>
            <p v-if="!!$route.query.operationType" class="video-time">
              视频总时长：{{ durationSec }}
            </p>
            <div
              v-show="itemTips.trialRange[currentFileIndex]"
              class="must-tip"
            >
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
      </div>
      <div class="sell-item">
        <div class="item-title">
          <span>*</span>
          <p>售卖方式</p>
          <div class="radio-list">
            <el-radio-group
              v-model="form.promotionTag[currentFileIndex]"
              :disabled="$route.query.operationType == 2"
            >
              <el-radio label="1">在线观看</el-radio>
              <el-radio label="2">允许下载</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="item-content"></div>
      </div>
      <div class="video-introduce-item">
        <div class="item-title">
          <span style="opacity: 0">*</span>
          <p>视频介绍</p>
        </div>
        <div class="item-content item-content-editor">
          <div class="editor-box">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              :style="
                $route.query.operationType == 2
                  ? 'height: 400px; overflow-y: hidden;cursor: not-allowed'
                  : 'height: 400px; overflow-y: hidden;'
              "
              v-model="form.resourceIntro[currentFileIndex]"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
              @onChange="onChange"
            />
          </div>
        </div>
      </div>
      <div v-if="!$route.query.operationType" class="album-item">
        <div class="item-title">
          <span style="opacity: 0">*</span>
          <p>加入专辑</p>
        </div>
        <p class="item-tips">创建新专辑需要上传3份及以上视频</p>
        <div class="item-content">
          <div class="abum-btn-box">
            <div
              class="upload-video-btn add-album-btn"
              :class="{
                'no-add-album': !!$route.query.operationType || createAlbumInfo,
              }"
              @click="addAlbum()"
            >
              <i class="iconfont icon-jiahao add-icon"></i>
              <p>请选择专辑</p>
            </div>
            <div
              class="upload-video-btn create-album-btn"
              :class="{
                'no-create-album': noCreateAlbum,
              }"
              @click="createOrEditAlbum('create')"
              :data-io-click="noCreateAlbum ? '' : 'tracker'"
            >
              <i class="iconfont icon-jiahao add-icon"></i>
              <p>创建专辑</p>
            </div>
          </div>
          <!-- 选择专辑的列表 -->
          <ul v-if="albumSelection.length > 0" class="album-list">
            <li
              class="album-li"
              v-for="(item, index) in albumSelection"
              :key="item.id"
            >
              <div class="album-type-icon"></div>
              <el-tooltip :content="item.albumName" placement="top">
                <p class="album-name">{{ item.albumName }}</p>
              </el-tooltip>
              <i
                class="iconfont icon-guanbi del-album"
                @click="delSelectAlbum(index)"
              ></i>
            </li>
          </ul>
          <!-- 创作专辑的列表 -->
          <ul v-if="createAlbumInfo" class="album-list2">
            <li class="album-li album-li2">
              <div class="album-type-icon"></div>
              <el-tooltip :content="createAlbumInfo.title" placement="top">
                <p class="album-name">
                  {{ createAlbumInfo.title }}
                </p>
              </el-tooltip>
              <i
                class="iconfont icon-guanbi del-album"
                @click="delCreateAlbum()"
              ></i>
              <img
                src="../../../assets/images/edit-icon.png"
                alt=""
                class="edit-icon"
                @click="createOrEditAlbum('edit')"
              />
            </li>
          </ul>
        </div>
      </div>
      <!-- 选择专辑弹窗 -->
      <selectAlbumDialog
        :show.sync="selectAlbumDialogVisible"
        :courseId="this.form.courseId[this.currentFileIndex]"
        :scenarioId="this.form.scenarioId[this.currentFileIndex]"
        :selectedList="this.albumSelection"
        @getSelectAlbum="getSelectAlbum"
      />
      <!-- 创建/修改专辑弹窗 -->
      <createAlbumDialog
        :show.sync="showCreateAlbumDialog"
        :type="currentAlbumDialogType"
        :albumInfo="createAlbumInfo"
        @getAlbumInfo="getAlbumInfo"
      />
      <!-- 上传最终确定的通用弹窗 -->
      <uploadTipDialog
        :show.sync="showUploadTipDialog"
        :dialogContent="dialogContent"
        :errorObj="errorObj"
        :dialogType="dialogType"
        @toList="failToList()"
        @confirm="sureDialog()"
      />
      <!-- 底部通栏 -->
      <footer class="footer">
        <div class="cancel" @click="cancelUpload()">取消</div>
        <div class="sure" @click="uploadCheck()">确定上传</div>
      </footer>
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import api from "../../../assets/js/api";
import axios from "@/assets/js/request";
import { Message } from "element-ui";
import store from "@/store";
import Sortable from "sortablejs";
import leaveUpload from "../../../mixin/leaveUpload.js";
import uploadTipDialog from "@/components/recourse-dialog/upload-tip-dialog.vue";
import selectAlbumDialog from "../../../components/recourse-dialog/select-album-dialog.vue";
import createAlbumDialog from "@/components/recourse-dialog/create-album-dialog.vue";

export default {
  name: "ShopCenterAdminWebVideoUpload",
  components: {
    Editor,
    Toolbar,
    uploadTipDialog,
    selectAlbumDialog,
    createAlbumDialog,
  },
  data() {
    return {
      editor: null,
      toolbarConfig: {
        // 隐藏哪些菜单
        excludeKeys: [
          "code",
          "sup",
          "sub",
          "todo",
          "insertLink",
          "codeBlock",
          "group-video",
          "insertTable",
          "fullScreen",
          "insertImage",
          "numberedList",
          "blockquote",
          "|",
        ],
      },
      editorConfig: {
        placeholder: "请输入视频介绍...",
        readOnly: this.$route.query.operationType == 2,
        autoFocus: false,
        // 选中内容时的悬浮菜单
        hoverbarKeys: {
          image: {
            // 清空 image 元素的 hoverbar
            menuKeys: [],
          },
          text: {
            // 清空 文本 元素的 hoverbar
            menuKeys: [],
          },
        },
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            // 自定义图片上传
            async customUpload(imgFile, insertFn) {
              // 限制为1mb
              if (imgFile.size > 1 * 1024 * 1024) {
                Message({
                  showClose: true,
                  message: "图片过大，请压缩后重试~",
                  type: "error",
                });
                return;
              }
              // 上传图片
              const formDate = new FormData();
              formDate.append("file", imgFile);
              // 不压缩直接进行上传
              const res = await axios.post(
                api.shopResource.uploadVideoIntroducePhoto,
                formDate
              );
              if (res.result.success) {
                // 最后插入图片
                insertFn(res.result.filePath, "", "");
                Message({
                  showClose: true,
                  message: "图片上传成功~",
                  type: "success",
                });
                return;
              } else {
                Message({
                  showClose: true,
                  message: "图片上传失败~",
                  type: "error",
                });
                return;
              }
            },
          },
        },
      },
      mode: "default",
      form: {
        // 表单数据
        fileUrl: [], // 视频
        fileName: [], // 视频名称
        coverUrl: [], // 封面
        resourceIntro: [], // 视频简介
        stageId: [], // 学段
        courseId: [], // 学科
        scenarioId: [], // 场景
        trialRange: [], // 试看范围
        promotionTag: ["1"], // 售卖方式
        albumIds: [], // 专辑数组
        year: [], // 年份
      },
      itemTips: {
        // 控制必填提示是否显示
        fileUrl: false,
        coverUrl: [false],
        courseId: [false],
        scenarioId: [false],
        trialRange: [false],
        year: [false],
      },
      fileTypes: [
        // 允许的视频格式
        "mp4",
        "avi",
        "wmv",
        "mov",
        "flv",
        "rmvb",
        "3gp",
        "mkv",
      ],
      coverTypes: [
        // 允许的封面格式
        "jpg",
        "jpeg",
        "png",
      ],
      videoFiles: [], // 所有选择的视频文件
      videoSuffixs: [], // 所有资料的后缀
      uploadingProgress: [], // 所有资料上传进度
      uploadingStatus: [], // 所有资料的上传状态
      showProgress: [], // 所有资料的是否显示进度条
      ossResult: [], // 所有资料的oss上传结果信息
      controller: [], // 所有上传请求的请求控制器
      tryLookRadio: ["1"], // 试看类型
      tryLookPlaceholder: "请输入固定时长", // 试看占位符
      coverFile: "", // 封面文件
      durationSec: "0秒", // 视频时长
      videoSeconde: 0, // 视频时长秒数
      courseList: [], // 学科列表
      sceneList: [], // 场景列表
      selectAlbumDialogVisible: false, // 选择专辑弹窗
      albumSelection: [], // 选中的专辑
      currentYear: 2024, // 当前年份
      yearList: [], // 年份列表
      shopType: this.$store.state.user.userInfo.businessType, // 店铺类型 2-第三方 其他-精品
      showUploadTipDialog: false, // 通用确认弹窗
      dialogContent: "", // 弹窗内容
      dialogType: "", // 弹窗类型 uploadFail-上传失败
      errorObj: {}, // 错误信息
      isSaved: false, // 是否为保存操作 决定是否触发beforeRouteLeave逻辑处理
      trialRangeValue: {
        // 暂存试看范围值 方便回显
        fixedTime: "", // 固定时长
        fixedRatio: "", // 固定比例
      },
      activeIndex: "/resource/video/list", // beforeRouteLeave取消路由跳转时 重新设置导航栏的选中状态
      courseAndStageMap: new Map(), // 学科与学段的哈希映射表
      isAllSet: false, // 是否批量操作
      currentFileIndex: 0, // 当前选中文件的索引
      showCreateAlbumDialog: false, // 是否展示创建专辑弹窗
      createAlbumInfo: null, // 创建的专辑信息
      currentAlbumDialogType: "create", // 当前专辑弹窗类型 create-创建 edit-编辑
      dataNames: [
        "videoFiles",
        "videoSuffixs",
        "uploadingStatus",
        "showProgress",
        "uploadingProgress",
        "ossResult",
        "controller",
        "tryLookRadio",
      ], // 每个文件所关联的数据名称
      editVideoDetail: {}, // 编辑的时候 获取的的视频详情
    };
  },
  computed: {
    // 是否不能创建专辑
    noCreateAlbum() {
      return (
        !!this.$route.query.operationType ||
        !!this.createAlbumInfo ||
        this.albumSelection.length > 0 ||
        this.ossResult.length < 3
      );
    },
  },
  mixins: [leaveUpload], // 路由守卫文件
  async mounted() {
    // 根据上传/编辑状态处理富文本编辑器的CSS样式
    if (this.$route.query.operationType == 2) {
      // 只读禁用状态
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--w-e-textarea-bg-color", "#f5f7fa");
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--w-e-toolbar-bg-color", "#f5f7fa");
    } else {
      // 正常状态
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--w-e-textarea-bg-color", "#fff");
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--w-e-toolbar-bg-color", "#fff");
    }
    //获取选项
    this.init();
    // 填充 编辑/查看 信息
    await this.getDetails(this.$route.query.resourceId);
    // 获取当前年份
    this.currentYear = new Date().getFullYear();
    // 获取年份列表信息
    for (let i = this.currentYear + 1; i >= this.currentYear - 9; i--) {
      this.yearList.push(i);
    }
    // 只有上传的时候需要开启拖拽
    if (!this.$route.query.operationType) {
      // 开启文件列表拖拽功能
      this.$nextTick(() => {
        // 开启拖拽排序
        var el = document.getElementById("file-list");
        new Sortable(el, {
          animation: 150,
          filter: ".no-change",
          onUpdate: (evt) => {
            // 改变相关数组数据的排序
            for (let name of this.dataNames) {
              let temp = this[name][evt.oldIndex];
              this[name].splice(evt.oldIndex, 1);
              this[name].splice(evt.newIndex, 0, temp);
            }
            // form文件信息
            for (let key in this.form) {
              if (key === "albumIds") {
                continue;
              }
              let temp = this.form[key][evt.oldIndex];
              this.form[key].splice(evt.oldIndex, 1);
              this.form[key].splice(evt.newIndex, 0, temp);
            }
            // 数据顺序修改完成后 切换选中的文件为当前拖拽的文件
            this.selectCurrentFile(evt.newIndex, "drag");
            // 文件列表需要重新按顺序渲染dom 确保视图和数据一致
            const arr = this.videoFiles.slice(0);
            this.videoFiles = [];
            this.$nextTick(() => {
              this.videoFiles = arr;
            });
          },
        });
      });
    }
  },
  methods: {
    init() {
      this.getCourseList();
      if (this.form.stageId[this.currentFileIndex]) {
        this.getScenarioList();
      }
    },
    // 获取学科列表
    async getCourseList() {
      const res = await this.$axios.get(api.shopResource.getStageAndSubject);
      if (res.valid) {
        this.courseList = res.result;
        // 建立学科与学段的哈希映射表
        res.result.forEach((item) => {
          this.setCourseAndStageMap(item.children, item.stageId);
        });
      }
    },
    // 递归建立学科与学段的哈希映射表
    setCourseAndStageMap(data, stageId) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (!item.children || item.children.length === 0) {
          delete item.children;
          this.courseAndStageMap.set(item.id, stageId);
        } else {
          this.setCourseAndStageMap(item.children, stageId);
        }
      }
    },
    // 获取场景列表
    async getScenarioList() {
      const scene = await this.$axios.get(
        api.shopResource.getScenarioList +
          "?stageId=" +
          this.form.stageId[this.currentFileIndex]
      );
      this.sceneList = scene.result.map((item) => {
        const obj = {
          id: item.id,
          label: item.label,
          leaf: false,
        };
        if (item.children.length === 0) {
          obj.leaf = true;
        } else {
          obj.children = item.children;
        }
        return obj;
      });
    },
    // 选择学科 之后 获取对应的学段和场景列表
    courseChange() {
      this.form.stageId[this.currentFileIndex] =
        this.courseAndStageMap.get(this.form.courseId[this.currentFileIndex]) ||
        "";
      // 如果设置的是有效学科学段
      if (
        this.form.stageId[this.currentFileIndex] &&
        this.form.courseId[this.currentFileIndex]
      ) {
        // 清空场景
        this.form.scenarioId[this.currentFileIndex] = "";
        // 获取场景列表
        this.getScenarioList();
      } else {
        this.sceneList = []; // 场景列表
      }
    },
    // 获取视频详情
    async getDetails(id) {
      if (!id) {
        return;
      }
      // 编辑/查看/定价 初始进入时 不显示进度条
      this.showProgress.push(false);
      const resource = await this.$axios.get(
        api.shopResource.getResourceDetails,
        { resourceId: id }
      );
      if (
        resource.result.rbmStatus === "废除" ||
        resource.result.rbmStatus === "审核中"
      ) {
        window.location.href = store.state.error.error401;
        return;
      }

      if (resource.result.status === "退稿") {
        const checkRejectRes = await this.$axios.get(
          api.shopResource.checkResourceRejectDate,
          { id: id }
        );
        if (checkRejectRes.result) {
          window.location.href = store.state.error.error401;
          return;
        }
      }

      const checkResult = await this.$axios.get(
        api.shopResource.checkResourceRukuStatus,
        { id: id }
      );
      if (!checkResult.result) {
        window.location.href = store.state.error.error401;
        return;
      }

      const res = JSON.parse(JSON.stringify(resource.result));
      this.editVideoDetail = res;
      let nameArr = res.fileName.split(".");
      const currentType = nameArr.pop();
      this.videoSuffixs.push(currentType);
      for (let key in this.form) {
        if (key === "fileName") {
          const arr = res[key].split(".");
          arr.pop();
          res[key] = arr.join(".");
        }
        this.form[key] = [res[key]];
      }
      // console.log(this.form);
      // 富文本编辑器不支持绑定null
      if (!this.form.resourceIntro[0]) {
        this.form.resourceIntro[0] = "";
      }
      // 回显视频封面 并增加参数 避免缓存
      this.form.coverUrl[0] =
        this.form.coverUrl[0] + "?" + new Date().getTime();
      // 回显视频文件名
      this.videoFiles.push({
        name: resource.result.fileName,
      });
      // 判断试看类型
      if (!this.form.trialRange[0]) {
        this.tryLookRadio[0] = "3";
        this.tryLookPlaceholder = "不允许试看";
      } else if (this.form.trialRange[0].indexOf("%") !== -1) {
        this.tryLookRadio[0] = "2";
        this.form.trialRange[0] = this.form.trialRange[0].replace("%", "");
        this.trialRangeValue.fixedRatio = this.form.trialRange[0];
      } else {
        this.tryLookRadio[0] = "1";
        this.trialRangeValue.fixedTime = this.form.trialRange[0];
      }
      // 获取场景列表
      this.getScenarioList();
      // 获取学科列表
      this.getCourseList();
      // 记录视频时长
      this.videoSeconde = resource.result.durationSec;
      // 将秒转换为时分秒
      const h = Math.floor(resource.result.durationSec / 3600);
      const m = Math.floor((resource.result.durationSec % 3600) / 60);
      const s = Math.floor((resource.result.durationSec % 3600) % 60);
      if (h > 0) {
        this.durationSec = h + "小时" + m + "分" + s + "秒";
      } else if (m > 0) {
        this.durationSec = m + "分" + s + "秒";
      } else {
        this.durationSec = s + "秒";
      }
    },
    // 模拟点击上传
    clickUpload(type) {
      if (type === "video") {
        this.$refs.videoFile.click();
      } else if (type === "cover") {
        this.$refs.coverFile.click();
      }
    },
    // 获取点击上传的文件
    selectFile(e, type) {
      // 如果是视频文件上传
      if (type === "video") {
        let fileList = [];
        // 记录当前文件上传添加之前的已存在文件数量
        let preCount = this.videoFiles.length;
        // 当前剩余可上传的数量
        let remainCount = 20 - preCount;
        // 判断用户选择的文件数量是否超过限制
        if (e.target.files.length > remainCount) {
          fileList = e.target.files.slice(0, remainCount);
        } else {
          fileList = e.target.files;
        }
        // 记录是否有重复的文件
        let hasRepeat = false;
        // 记录是否有格式不正确的文件
        let hasFormat = false;
        // 记录是否有大小超出限制的文件
        let hasSize = false;
        for (let i = preCount; i < preCount + fileList.length; i++) {
          const file = fileList[i - preCount];
          // 创建请求控制器
          this.controller.push(new AbortController());
          // 根据文件名判断文件是否重复
          const isHad = this.videoFiles.some((item) => {
            return item.name === file.name;
          });
          if (isHad) {
            // 如果这是第一次发现重复 则标记出现重复
            if (!hasRepeat) hasRepeat = true;
            this.controller.pop();
            continue;
          }
          // 没重复 则继续向下执行
          this.videoFiles.push(file);
          const currentIndex = this.videoFiles.length - 1;
          const typeArr = this.videoFiles[currentIndex].name.split(".");
          const currentType = typeArr[typeArr.length - 1];
          if (!this.fileTypes.includes(currentType)) {
            // 如果这是第一次发现类型错误 则标记出现类型错误
            if (!hasFormat) hasFormat = true;
            this.videoFiles.pop();
            this.controller.pop();
            continue;
          } else if (this.videoFiles[currentIndex].size > 1024 * 1024 * 500) {
            // 如果这是第一次发现文件大小错误 则标记出现文件大小错误
            if (!hasSize) hasSize = true;
            this.videoFiles.pop();
            this.controller.pop();
            continue;
          } else {
            // 做上传准备
            this.uploadingProgress.push(0);
            this.uploadingStatus.push("上传中");
            this.showProgress.push(true);
            this.tryLookRadio.push("1");
            for (let key in this.form) {
              if (["fileUrl", "fileName", "albumIds"].includes(key)) {
                continue;
              }
              // 这个地方之所以使用下标操作 是为了避免用户再上传文件之前操作过标签选项的情况
              if (key === "promotionTag") {
                // 售卖类型需要单独处理
                this.form[key][i] = "1";
              } else {
                this.form[key][i] = "";
              }
            }
            // 文件名做单独处理
            let currentFileName = "";
            typeArr.pop();
            currentFileName = typeArr.join(".");
            // 将处理后的文件名存储到form.fileName中
            this.form.fileName.push(currentFileName);
            // 将文件后缀存储到videoSuffixs中
            this.videoSuffixs.push(currentType);
            // 开始上传视频
            this.uploadVideo(currentIndex);
          }
        }
        // 如果只选择了一个文件
        if (fileList.length === 1) {
          // 则按顺序触发错误提示
          if (hasRepeat) {
            this.$message.error("请勿重复上传~");
          } else if (hasFormat) {
            this.$message.error("视频文件格式不正确，请重新选择~");
          } else if (hasSize) {
            this.$message.error("视频文件大小不能超过500M~");
          }
        } else {
          // 如果选择了多个文件 则统一提示
          if (hasRepeat || hasFormat || hasSize) {
            this.$message.error("视频文件格式或大小不符合要求，请重新选择~");
          }
        }
        // 清除input标签的文件缓存 否则选择同一文件不会触发change事件
        this.$refs.videoFile.value = "";
        // 调用推断标签接口 preCount 表示当前要推断的资料名称是从哪个索引开始的
        this.autoInferTag(preCount);
      } else if (type === "cover") {
        // console.log("选中的封面文件");
        this.coverFile = e.target.files[0];
        const typeArr = this.coverFile.type.split("/");
        if (typeArr[0] !== "image" || !this.coverTypes.includes(typeArr[1])) {
          this.$message.error("图片格式不正确，请重新选择~");
          return;
        } else if (this.coverFile.size > 1024 * 500) {
          this.$message.error("图片文件大小不能超过500KB~");
          return;
        } else {
          // 这个地方开始上传封面
          this.uploadCover();
        }
        // 清除input标签的文件缓存 否则选择同一文件不会触发change事件
        this.$refs.coverFile.value = "";
      }
    },
    // 删除视频
    delVideo(currentIndex) {
      // 上传过程中点击删除 则终止上传请求
      if (
        this.uploadingProgress[currentIndex] < 100 &&
        this.uploadingProgress[currentIndex] > 0
      ) {
        this.controller[currentIndex].abort();
      } else {
        // 只有上传完成后才能删除ossResult中的数据
        this.ossResult.splice(currentIndex, 1);
      }
      // 清除input标签的文件缓存 否则选择同一文件不会触发change事件
      this.$refs.videoFile.value = "";
      // 无论是否上传成功都要删除的信息
      for (let name of this.dataNames) {
        if (!["ossResult"].includes(name)) {
          this[name].splice(currentIndex, 1);
        }
      }
      // 要删除的form信息
      for (let key in this.form) {
        if (!["fileUrl", "albumIds"].includes(key)) {
          this.form[key].splice(currentIndex, 1);
        }
      }
      // 如果删除的是当前选中的文件，则默认选中第一位
      if (this.currentFileIndex === currentIndex) {
        this.selectCurrentFile(0);
      }
    },
    // 选中当前视频文件
    selectCurrentFile(index, type) {
      // 如果是批量操作 则无法切换选中 或者选中的文件就是当前文件 无需切换选中
      if ((this.isAllSet && type !== "drag") || this.currentFileIndex === index)
        return;
      // 记录当前选中文件的索引
      this.currentFileIndex = index;
      // 根据设置的学科学段重新请求场景列表
      if (
        this.form.stageId[this.currentFileIndex] &&
        this.form.courseId[this.currentFileIndex]
      ) {
        // 获取场景列表
        this.getScenarioList();
      } else {
        this.sceneList = []; // 场景列表
      }
    },
    // 获取上传文件所需要的token
    async getToken(currentIndex) {
      const fileName = this.videoFiles[currentIndex].name;
      const token = await this.$axios.get(
        api.ossUpload.getOssUploadToken +
          "?fileName=" +
          encodeURIComponent(fileName)
      );
      return token.result[fileName];
    },
    // 上传视频
    async uploadVideo(currentIndex) {
      // 获取token
      const token = await this.getToken(currentIndex);
      // 对接阿里云上传
      let uploadData = new FormData();
      for (let t in token) {
        uploadData.append(t, token[t]);
      }
      uploadData.append("success_action_status", "200");
      uploadData.append("file", this.videoFiles[currentIndex]);
      try {
        const res = await this.$axios.post(api.ossUpload.aliYun, uploadData, {
          onUploadProgress: (progressEvent) => {
            this.$set(
              this.uploadingProgress,
              currentIndex,
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          },
          timeout: 0, // 设置超时时间为 0/null 表示永不超时
          signal: this.controller[currentIndex].signal, // 设置取消请求的信号量
        });
        this.$set(this.uploadingStatus, currentIndex, "上传成功");
        // 上传成功后将返回的结果赋值给ossResult
        this.$set(this.ossResult, currentIndex, res);
        // this.ossResult[currentIndex] = res;
        // 如果当前资料为第一个上传成功的资料 则自动推断标签
        // if (currentIndex === 0) {
        //   this.autoInferTag();
        // }
      } catch (error) {
        // 取消上传 则不修改上传状态为失败
        if (error.message == "canceled") return;
        this.$set(this.uploadingStatus, currentIndex, "失败");
      }
    },
    // 根据视频名称自动推断资料标签
    async autoInferTag(startIndex) {
      // 当前要进行推断的文件名
      const names = this.form.fileName.slice(startIndex);
      const res = await this.$axios.post(
        api.shopResource.autoInferResourceTag,
        names
      );
      // 回显推断的标签
      if (res.result) {
        res.result.forEach((item, index) => {
          // 注意索引
          index = startIndex + index;
          this.form.courseId[index] =
            item.courseId || this.form.courseId[index];
          this.form.scenarioId[index] =
            item.scenarioId || this.form.scenarioId[index];
          this.form.stageId[index] = item.stageId || this.form.stageId[index];
          this.form.year[index] = item.year || this.form.year[index];
        });
        if (this.form.stageId[this.currentFileIndex]) {
          // 获取场景列表
          this.getScenarioList();
          // 获取学科列表
          this.getCourseList();
        }
      }
    },
    // 上传的封面图片转为base64
    uploadCover() {
      var reader = new FileReader();
      reader.readAsDataURL(this.coverFile);
      reader.onload = () => {
        this.$set(this.form.coverUrl, this.currentFileIndex, reader.result);
      };
    },
    // 试看范围类型改变
    tryLookChange(e) {
      this.form.trialRange[this.currentFileIndex] = "";
      // 修改提示词并回显数据
      if (e === "1") {
        this.tryLookPlaceholder = "请输入固定时长";
        this.form.trialRange[this.currentFileIndex] =
          this.trialRangeValue.fixedTime;
      } else if (e === "2") {
        this.tryLookPlaceholder = "请输入固定比例";
        this.form.trialRange[this.currentFileIndex] =
          this.trialRangeValue.fixedRatio;
      } else if (e === "3") {
        this.tryLookPlaceholder = "不允许试看";
      }
    },
    // 试看范围值改变
    tryLookChangeValue(e) {
      // 判断是否为纯数字的正则表达式
      const reg = /^[0-9]*$/;
      if (!reg.test(e)) {
        while (!reg.test(e)) {
          e = e.slice(0, e.length - 1);
          this.form.trialRange[this.currentFileIndex] = e;
        }
      } else if (
        (this.tryLookRadio === "2" && Number(e) > 100) ||
        Number(e) == 0
      ) {
        e = e.slice(0, e.length - 1);
        this.form.trialRange[this.currentFileIndex] = e;
      }
      // 暂存试看范围值
      if (this.tryLookRadio == "1") {
        this.trialRangeValue.fixedTime =
          this.form.trialRange[this.currentFileIndex];
      } else if (this.tryLookRadio == "2") {
        this.trialRangeValue.fixedRatio =
          this.form.trialRange[this.currentFileIndex];
      }
    },
    // 选择专辑点击事件
    addAlbum() {
      if (this.$route.query.operationType || this.createAlbumInfo) return;
      this.selectAlbumDialogVisible = true;
    },
    // 创建/编辑专辑
    createOrEditAlbum(type) {
      // 如果已经创建了专辑 或者已经选择了专辑 则不能再创建专辑
      if (type === "create" && this.noCreateAlbum) {
        return;
      }
      this.currentAlbumDialogType = type;
      this.showCreateAlbumDialog = true;
    },
    // 删除创建的专辑
    delCreateAlbum() {
      this.createAlbumInfo = null;
    },
    // 删除选择的专辑
    delSelectAlbum(index) {
      this.albumSelection.splice(index, 1);
    },
    // 最终上传前的校验
    async uploadCheck() {
      let isPass = true;
      // 校验必填项
      for (let key in this.form) {
        if (key === "fileUrl" || key === "fileName") {
          // 根据上传文件判断是否为空
          if (this.videoFiles.length > 0) {
            this.itemTips[key] = false;
            // 再针对fileName中每个文件名进行判空校验
            if (key === "fileName") {
              this.form[key].some((item) => {
                if (item.toString().trim().length === 0) {
                  isPass = false;
                  this.$message.error("视频名称不能为空，请重新编辑~");
                }
              });
            }
          } else {
            this.itemTips[key] = true;
            isPass = false;
          }
        } else if (key in this.itemTips) {
          // 如果是批量操作
          if (this.isAllSet) {
            // 只需校验当前资料的各项信息
            if (this.form[key][this.currentFileIndex].length === 0) {
              this.$set(this.itemTips[key], this.currentFileIndex, true);
              isPass = false;
            } else {
              this.$set(this.itemTips[key], this.currentFileIndex, false);
            }
          } else {
            // 非批量操作 需要校验每个资料的各项信息
            this.form[key].forEach((item, index) => {
              if (!item || item.length === 0) {
                this.$set(this.itemTips[key], index, true);
                isPass = false;
              } else {
                this.$set(this.itemTips[key], index, false);
              }
            });
          }
        }
      }
      // 如果必填项校验未通过 结束执行
      if (!isPass) {
        // 如果不是批量操作 且 因为封面/学科/场景/试看范围/年份必填项未填 则Toast提示
        if (
          !this.isAllSet &&
          (this.itemTips.coverUrl.find((item) => item) ||
            this.itemTips.courseId.find((item) => item) ||
            this.itemTips.scenarioId.find((item) => item) ||
            this.itemTips.trialRange.find((item) => item) ||
            this.itemTips.year.find((item) => item))
        ) {
          this.$message.warning("部分视频信息不完整，请检查补充~");
        }
        return;
      }
      // 校验专辑和视频的学科是否一致
      if (this.createAlbumInfo) {
        // 如果是批量操作 且 当前视频的课程不等于专辑课程
        // 如果不是批量操作 且 存在视频的课程不等于专辑课程
        if (
          (this.isAllSet &&
            this.form.courseId[this.currentFileIndex] !==
              this.createAlbumInfo.courseId) ||
          (!this.isAllSet &&
            this.form.courseId.findIndex(
              (item) => item !== this.createAlbumInfo.courseId
            ) !== -1)
        ) {
          this.$message.warning("视频与专辑的学科不一致，请修改~");
          return;
        }
      }
      // 如果是选择的专辑
      else if (this.albumSelection.length > 0) {
        // 获取专辑列表中所有专辑的所有课程id
        const albumCourseIds = [];
        this.albumSelection.forEach((item) => {
          albumCourseIds.push(...item.courseIds);
        });
        // 如果是批量操作 且 当前资料的课程不在专辑课程之内
        // 如果不是批量操作 且 存在资料的课程不在专辑课程之内
        if (
          (this.isAllSet &&
            !albumCourseIds.includes(
              this.form.courseId[this.currentFileIndex]
            )) ||
          (!this.isAllSet &&
            this.form.courseId.findIndex(
              (item) => !albumCourseIds.includes(item)
            ) !== -1)
        ) {
          this.$message.warning("视频与专辑的学科不一致，请修改~");
          return;
        }
      }
      if (this.$route.query.operationType) {
        this.dialogContent = "请确认是否保存此次编辑？";
      } else {
        this.dialogContent = "请确认是否上传该视频？";
      }

      this.showUploadTipDialog = true;
    },
    // 取消上传返回列表页
    cancelUpload() {
      this.isSaved = false;
      this.$router.push({
        name: "resource-video-list",
        params: this.$route.params,
      });
    },
    // 弹窗确定事件
    sureDialog() {
      this.showUploadTipDialog = false;
      if (
        this.dialogContent === "请确认是否上传该视频？" ||
        this.dialogContent === "请确认是否保存此次编辑？"
      ) {
        this.sureUpload();
      }
    },
    // 确定上传
    async sureUpload() {
      this.showUploadTipDialog = false;
      // 开启loading
      const loading = this.$loading({
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {};
      // 如果是创建专辑
      if (this.createAlbumInfo) {
        params = { ...this.createAlbumInfo };
        params.gradeIds = this.createAlbumInfo.gradeIds;
        delete params.gradeId;
      }
      // 如果是选择专辑
      else if (this.albumSelection.length > 0) {
        this.form.albumIds = [];
        this.albumSelection.forEach((item) => {
          this.form.albumIds.push(item.albumId);
        });
      }
      // 资料信息列表
      params.resourceList = [];
      // 是否批量操作
      params.batchOperation = this.isAllSet;
      this.videoFiles.forEach((item, index) => {
        let curIndex = null;
        // 如果是批量操作 则都取当前文件的标签
        if (this.isAllSet) {
          curIndex = this.currentFileIndex;
        }
        params.resourceList.push({
          coverUrl: this.form.coverUrl[curIndex] || this.form.coverUrl[index],
          stageId: this.form.stageId[curIndex] || this.form.stageId[index],
          courseId: this.form.courseId[curIndex] || this.form.courseId[index],
          scenarioId:
            this.form.scenarioId[curIndex] || this.form.scenarioId[index],
          albumIds: this.form.albumIds,
          year: this.form.year[curIndex] || this.form.year[index],
          resourceIntro:
            this.form.resourceIntro[curIndex] || this.form.resourceIntro[index],
          promotionTag:
            this.form.promotionTag[curIndex] || this.form.promotionTag[index],
          trialRange:
            this.form.trialRange[curIndex] || this.form.trialRange[index],
        });
        params.resourceList[index].title = this.form.fileName[index];
        params.resourceList[index].fileName =
          this.form.fileName[index] + "." + this.videoSuffixs[index];
        params.resourceList[index].fileUrl =
          this.ossResult[index]?.key || this.form.fileUrl[index];
        // 设置试看范围的单位
        // 如果是批量操作 且选中的文件的试看范围是固定比例
        // 如果不是批量操作 且当前处理文件的试看范围是固定比例
        if (
          (this.isAllSet && this.tryLookRadio[curIndex] === "2") ||
          (!this.isAllSet && this.tryLookRadio[index] === "2")
        ) {
          params.resourceList[index].trialRange += "%";
        }
      });

      if (this.$route.query.operationType) {
        // 在编辑时 需要传递一些原有的参数
        const requestParams = Object.assign(
          {},
          this.editVideoDetail,
          params.resourceList[0]
        );
        const res = await this.$axios.post(
          api.shopResource.updateResourceInfo,
          requestParams
        );
        // 关闭loading
        loading.close();
        if (res.valid) {
          this.$message.success("编辑成功");
          // 标志为保存操作 不触发beforeRouteLeave逻辑处理
          this.isSaved = true;
          this.$router.push({
            name: "resource-video-list",
            params: this.$route.params,
          });
        } else {
          this.$message.error(
            res.error.message || "编辑失败，请重试或联系客服~"
          );
        }
      } else {
        const res = await this.$axios.post(
          api.shopResource.uploadResourceInfoV3,
          params
        );
        // 关闭loading
        loading.close();
        if (res.valid) {
          this.$message.success("上传成功");
          // 标志为保存操作 不触发beforeRouteLeave逻辑处理
          this.isSaved = true;
          this.$router.push({
            name: "resource-video-list",
            params: this.$route.params,
          });
        } else {
          try {
            this.errorObj = JSON.parse(res.error.message);
            this.dialogType = "uploadFail";
            this.showUploadTipDialog = true;
          } catch (error) {
            this.$message.error(
              res.error.message || "上传失败，请重试或联系客服~"
            );
          }
        }
      }
    },
    // 部分文件上传失败后，弹窗按钮点击事件
    failToList() {
      // 标志为保存操作 不触发beforeRouteLeave逻辑处理
      this.isSaved = true;
      this.$router.push({
        name: "resource-document-list",
        params: this.$route.params,
      });
    },
    // 创建富文本编辑器的回调
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    // 富文本编辑器内容改变的回调（数据回显导致的获取焦点问题）
    onChange() {},
    // 获取创建的专辑信息
    getAlbumInfo(e) {
      this.createAlbumInfo = e;
    },
    // 获取选择的专辑信息
    getSelectAlbum(e) {
      this.albumSelection = JSON.parse(JSON.stringify(e));
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style
  src="../../../../node_modules/@wangeditor/editor/dist/css/style.css"
></style>
<style lang="scss" scoped>
.video-page {
  position: relative;
  width: 100%;
  padding-bottom: 105px;
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 2;
    width: calc(100% + 40px);
    height: 70px;
    background-color: #fff;

    .cancel {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      margin-right: 60px;
      transform: translateX(120px);
      background: #ffffff;
      border: 1px solid #dddfe6;
      border-radius: 3px;
      color: #606266;
      cursor: pointer;
    }
    .sure {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      transform: translateX(120px);
      color: #fff;
      background: #5a83ff;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
.video-page-body {
  width: 900px;
  margin: auto;
  padding: 40px 0px 60px 50px;
  background-color: #fff;
  border-radius: 5px;

  .item-title {
    display: flex;
    align-content: center;
    justify-content: flex-start;

    span {
      margin-right: 5px;
      color: #fe4509;
    }

    p {
      margin-right: 15px;
      color: #333;
    }

    .item-tips {
      margin-top: 0px;
      padding-left: 12px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      color: #c4c8d0;
    }

    .radio-list {
      margin-left: 30px;

      ::v-deep .el-radio {
        margin-right: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #606266;
      }
    }
  }
  .item-tips {
    margin-top: 5px;
    padding-left: 12px;
    height: 20px;
    font-size: 12px;
    line-height: 20px;
    color: #c4c8d0;
  }
  .item-content {
    margin-top: 15px;
    margin-bottom: 16px;
    padding-left: 12px;
    display: flex;
    align-content: center;
    justify-content: flex-start;
    ::v-deep .el-cascader,
    ::v-deep .el-select {
      width: 300px;
    }
    .upload-btn-box {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .upload-video-btn {
      width: 156px;
      height: 32px;
      border: 1px dashed #a3baff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #5a83ff;
      cursor: pointer;
      opacity: 1;
      .add-icon {
        font-size: 12px;
        margin-right: 6px;
      }

      p {
        line-height: 32px;
      }

      &:hover {
        opacity: 0.9;
      }
    }

    .add-album-btn:hover {
      opacity: 0.6;
    }

    .no-add-album {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;

      span {
        color: #c0c4cc;
      }

      &:hover {
        opacity: 1;
      }
    }

    .video-info {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 10px;
      .sort-icon {
        position: absolute;
        top: 50%;
        left: -21px;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
      }
      .video-name-box {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        width: 678px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #dddfe6;
        border-radius: 5px;

        .video-icon {
          width: 14px;
          height: 14px;
          margin: 0 10px 0 14px;
        }

        .video-name {
          display: block;
          width: 610px;
          height: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
          color: #606266;
          border: 0;
          &:focus-visible {
            outline: none;
          }
        }
        .video-del {
          position: absolute;
          right: 10px;
          top: 8px;
          width: 14px;
          height: 14px;
          color: #c4c8d0;
          cursor: pointer;
          &:hover {
            color: rgba(237, 123, 47, 0.5);
          }
        }
        .video-again {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 14px;
          height: 14px;
          background-image: url(../../../assets/images/video-again.png);
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
      .current-file {
        border: 1px solid #5a83ff;
      }

      .only-look {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        cursor: not-allowed;

        .video-name {
          background-color: #f5f7fa;
          color: #c0c4cc;
          cursor: not-allowed;
        }
      }

      .uploading-box {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-left: 15px;

        .upload-status {
          font-size: 12px;
          margin-right: 10px;
          color: #5a83ff;
          // 不换行
          white-space: nowrap;
        }

        .upload-success {
          color: #00a870;
        }
        .upload-error {
          color: #e34d59;
        }

        ::v-deep .el-icon-circle-close::before {
          // content: url(../../assets/images/error-icon.png);
          content: " ";
          display: inline-block;
          background-image: url(../../../assets/images/error-icon.png);
          width: 14px;
          height: 14px;
          margin-right: 5px;
          background-size: 14px 14px;
        }
      }
    }

    .upload-cover-btn {
      width: 133px;
      height: 70px;
      border: 1px dashed #a3baff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #5a83ff;
      cursor: pointer;
      .add-icon {
        font-size: 12px;
        margin-right: 6px;
      }

      p {
        line-height: 70px;
      }
      &:hover {
        opacity: 0.9;
      }
    }

    .cover-img {
      position: relative;
      width: 133px;
      height: 70px;
      border-radius: 3px;
      background-size: 100% 100%;
      cursor: pointer;

      &:hover {
        .masking {
          opacity: 1;
        }
      }
      .mengban-box {
        width: 100%;
        height: 100%;
        background: rgba(245, 247, 250, 0.6);
        border-radius: 3px;
        cursor: not-allowed;
      }
      .masking {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        color: #fff;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.3);
        opacity: 0;
        border-radius: 3px;
        transition: all 0.3s linear;
      }
    }

    .video-time {
      position: absolute;
      bottom: -35px;
      left: 8px;
      margin-left: 20px;
      font-size: 12px;
      color: #c4c8d0;
      line-height: 40px;
    }
    .must-tip {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;

      .must-tip-icon {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }

      span {
        font-size: 12px;
        color: #fe4509;
      }
    }
    .album-list,
    .album-list2 {
      .album-li {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 678px;
        height: 32px;
        margin-top: 10px;
        background: #ffffff;
        border: 1px solid #dddfe6;
        border-radius: 5px;

        .album-type-icon {
          width: 11px;
          height: 14px;
          margin: 0 10px 0 14px;
          background-image: url(../../../assets/images/pc-decoration/album-icon.png);
          background-size: 100% 100%;
        }
        .album-name {
          width: 610px;
          // 单行超出省略号
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .del-album {
          font-size: 14px;
          margin-left: 10px;
          color: #c4c8d0;
          cursor: pointer;

          &:hover {
            color: rgba(237, 123, 47, 0.5);
          }
        }
      }
    }
    .album-list2 {
      .album-li2 {
        position: relative;
        width: 678px;
        .album-name {
          width: 610px;
        }
        .edit-icon {
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
    }
  }

  .item-content2 {
    display: block;
  }
  .item-content-editor {
    padding-right: 50px;
  }
  .try-item .item-content {
    position: relative;
    width: 300px;
  }
  .video-introduce-item .item-content {
    position: relative;
    display: block;
    .editor-box {
      border: 1px solid #dddfe6;
      border-radius: 5px;
      overflow: hidden;
    }

    .no-change-editor {
      position: absolute;
      top: 0;
      left: 12px;
      bottom: 0;
      right: 0;
      z-index: 1;
      height: 100%;
      background: rgba($color: #f3f3f3, $alpha: 0.6);
    }
  }

  .album-item .item-content {
    display: block;
    .abum-btn-box {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .create-album-btn {
        width: auto;
        padding: 0 10px;
        margin-left: 20px;
        border: 1px dashed transparent;
      }
      .no-create-album {
        color: #c4c8d0;
        cursor: not-allowed;
      }
    }
  }

  .grade-subjecj-item,
  .scene-date-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    & > div {
      width: 380px;
    }
  }
  .batch-operations-item {
    padding-left: 12px;
    margin-bottom: 35px;
    ::v-deep .el-checkbox__label {
      color: #606266;
      font-size: 12px;
      font-weight: 400;
      line-height: 12px; /* 100% */
    }
    & > p {
      margin-bottom: 15px;
      color: #f58800;
      font-size: 12px;
      line-height: 12px; /* 100% */
    }
  }
}
</style>
<style>
.el-progress__text {
  font-size: 12px !important;
}
</style>
